module.exports = "https://i.geely.com//img/loading.8a7630ca.gif";